export default {"src":"/_next/static/media/minus.cce4dcac.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};